/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * Method lets you get cryptographically strong random values.
 *
 * @returns  an integer represents the random value generated
 */
export const getRandomNumber = () => window.crypto.getRandomValues(new Uint32Array(1))[0];

/**
 * Generates a random GUID.
 */
export const getGuid = () => {
    const guidSegment = (length: number) => {
        let out: string = '';

        for (let i: number = 0; i < length; i++) {
            const rng = getRandomNumber() / 2 ** 32;

            // eslint-disable-next-line no-bitwise
            out += (((1 + rng) * 0x10000) | 0).toString(16).substring(1);
        }

        return out;
    };

    return [guidSegment(2), guidSegment(1), guidSegment(1), guidSegment(1), guidSegment(3)].join('-');
};
